import * as React from "react";
import styled, { css } from "styled-components";
import { StatCard } from "components/common";
import NumberUtils from "util/NumberUtils";
import StringUtils from "util/StringUtils";
import { distinctValues, shareOfTotal, tokensPerRun } from "ai-management/token-usage/usageSummary";
const Tiles = styled.section(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: ${theme.spacings.md};

    @media (max-width: ${theme.breakpoints.max.md}) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  `
);
const countOf = (count, singular, plural) => `${NumberUtils.formatNumber(count)} ${StringUtils.pluralize(count, singular, plural)}`;
const scopeText = ({ rows, totals }) => [
  countOf(totals.runs, "run", "runs"),
  countOf(distinctValues(rows, "feature_id").length, "feature", "features"),
  countOf(distinctValues(rows, "model").length, "model", "models")
].join(" \xB7 ");
const shareText = (share) => share === void 0 ? void 0 : `${NumberUtils.formatPercentage(share)} of total`;
const UsageStats = ({ usage }) => {
  const { totals } = usage;
  return /* @__PURE__ */ React.createElement(Tiles, { "aria-label": "Token usage summary" }, /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "primary",
      label: "Total tokens",
      value: NumberUtils.formatNumber(totals.tokens.total_tokens),
      subValue: `Across ${scopeText(usage)}`
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "info",
      label: "Input tokens",
      value: NumberUtils.formatNumber(totals.tokens.input_tokens),
      subValue: shareText(shareOfTotal(totals.tokens.input_tokens, totals)),
      helpText: "Every prompt token the models processed, including tokens read from or written to a prompt cache."
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "success",
      label: "Output tokens",
      value: NumberUtils.formatNumber(totals.tokens.output_tokens),
      subValue: shareText(shareOfTotal(totals.tokens.output_tokens, totals)),
      helpText: "Every token the models generated, including reasoning and thinking tokens."
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "gray",
      label: "Avg per run",
      value: NumberUtils.formatNumber(tokensPerRun(totals.tokens.total_tokens, totals.runs)),
      subValue: "tokens / run"
    }
  ));
};
export default UsageStats;
